import { Component, ElementRef, Inject, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Criteria, ExternalMemberService } from "src/app/Service/member/external-member.service";
import { IOrganizationViewModel } from "src/app/ViewModel/OrganizationModel";
import { IEipSessionValue, IEipUserModel, IMemeberloginInputModel, IMemeberloginViewModel, IMemebersViewModel } from 'src/app/ViewModel/MembersModel';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { CommonService } from 'src/app/Service/Common.service';
import { EncryptDecryptService } from "src/app/Service/encrypt-decrypt.service";
import { NotificationService } from "src/app/Service/notification.service";
import { Subscription } from "rxjs";


@Component({
    selector: 'app-master-member-dialog',
    templateUrl: './edit-member-dialog.component.html',
    styleUrls: ['./edit-member-dialog.component.css']
})
export class EditMemberComponent implements OnInit {
    isValidLntUser: boolean = false;
    hide: boolean = true;
    criteriaMap: any = new Map<Criteria, RegExp>();
    customValidators: Criteria[] | any = Object.keys(Criteria).map((key: any) => Criteria[key]);
    _is8Characters!: boolean;
    _isSymbols!: boolean;
    _isComplexWord!: boolean;
    isEditUser: boolean = false;
    selectedOption: string = 'ltMember';
    isInternalUser: boolean = true;
    public actionButtonText: string = "Save";
    memberId!: number;
    password!: FormControl;
    psNo: FormControl = new FormControl('', [Validators.required, Validators.maxLength(15), Validators.pattern('^[0-9]*$')])
    public memForm!: FormGroup;
    businessGroups: IOrganizationViewModel[] = [];
    selectedGroup: any;

    /*
      Sheriya changes comment for production issue 
    */
    // placeholder: string = "Enter for a search (at least three letters)";
    // login_Name = '';
    // comment = "*Weblogin already taken";
    // public searchList!: IMemeberloginViewModel[];
    // @ViewChild('searchInput') searchInput!: ElementRef;
    
    /**Member Details array */
    membersList: IMemebersViewModel;

    /*
      Sheriya changes comment for production issue
    */
    // public copymemberList: IMemebersViewModel[] = [];
    // isexistUser: boolean = false;

    UnsubscribeArray: Subscription[] = [];
    constructor(public _dialogRef: MatDialogRef<EditMemberComponent>, public _formBuilder: FormBuilder, private _extMemberService: ExternalMemberService, private _commonService: CommonService,
        @Inject(MAT_DIALOG_DATA) public _data: any, private encryptDecryptService: EncryptDecryptService, private _notificationService: NotificationService) {
        this.businessGroups = _data.businessGroups;
        this.selectedGroup = _data.selectedGroup;
        this.membersList = _data.member;

        /*
            Sheriya changes comment for production issue
        */
        //this.copymemberList = _data.memberList;
        
    }
    /**
     * ngOnInit - Angular Lifecycle hook
     */
    ngOnInit() {
        this._extMemberService.getCriteriaMap(this.criteriaMap);
        this.password = new FormControl('',
            [...this.customValidators.map((criteria: Criteria) => Validators.pattern(this.criteriaMap.get(criteria)))]);
        this.memberId = this._commonService.getLoggedInUserId();
        this.createForm();
        // Code revert for production issue
        this.memForm.get('psNo').valueChanges.subscribe(res => {
            this.fetchEipUserDetails();
        })
        this.memForm.get('webLogin').valueChanges.subscribe(res => {
            this.fetchEipUserDetails();
        })
        if (this.membersList != null) {
            this.isEditUser = true;
            this.setFormValues();
            this.isInternalUser = this.membersList.is_Internal;
            if (this.isInternalUser) {
                this.selectedOption = "ltMember";
                this.setLntMemberFormControls();
            }
            else {
                this.selectedOption = "othMember";
                this.setOtherMemerFormControls();
            }
            this.actionButtonText = "Update";
        }
        else
            this.setLntMemberFormControls();
    }

    setEipUserValues(eipRes: IEipSessionValue[], sessionCode: string, formControlName: string) {
        let sessionValue: IEipSessionValue = eipRes.filter(x => x.sessionCode == sessionCode)[0];
        if (!!sessionValue)
            this.memForm.get(formControlName)?.setValue(sessionValue.sessionValue);
    }

    //code reverted for production issue

    fetchEipUserDetails() {
        this.isValidLntUser = false;
        let psNo: string = this.getFormValue('psNo')
        let eccWebLogin: string = this.getFormValue('webLogin')
        if (!!psNo && !!eccWebLogin && psNo.length > 0 && eccWebLogin.length > 0) {
            let eipUserModel: IEipUserModel = { referenceId: +psNo, username: eccWebLogin };
            this._extMemberService.GetEipUserDetails(eipUserModel).subscribe((eipRes: IEipSessionValue[]) => {
                if (eipRes.length > 0) {
                    this.setEipUserValues(eipRes, "SSUserFullName", "memName");
                    if (!this.isEditUser) {
                        this.setEipUserValues(eipRes, "SSUserMailID", "emailId");
                        this.setEipUserValues(eipRes, "SSUserMobileNo", "mobileNo");
                    }
                    this.setEipUserValues(eipRes, "SSUserId", "eipUserId");
                    this.setEipUserValues(eipRes, "SSCompanyCode", "companyCode");
                    this.isValidLntUser = true;
                }
                else
                {
                    this.isValidLntUser = false;
                }
            })
        }
    }

    createForm() {
        this.memForm = this._formBuilder.group({
            psNo: this.psNo,
            memName: new FormControl('', [Validators.required, Validators.maxLength(600)]),
            memShortName: new FormControl('', [Validators.required, Validators.maxLength(200)]),
            webLogin: new FormControl('', [Validators.required, Validators.maxLength(50)]),
            emailId: new FormControl('', [Validators.required, Validators.email, Validators.maxLength(150)]),
            mobileNoPrefix: new FormControl('+91', [Validators.pattern('^\\+[0-9]{1,4}$')]),
            mobileNo: new FormControl('', [Validators.pattern('^\\d{8,11}$')]),
            designation: new FormControl('', [Validators.maxLength(200)]),
            businessGroup: new FormControl('', Validators.required),
            status: new FormControl(true),
            eipUserId: new FormControl(''),
            companyCode: new FormControl(''),
            txtAddress: new FormControl('')

        });
    }

    /**
     * Set form values
     */
    setFormValues() {
        this.memForm.get('psNo')?.setValue(this.membersList.staff_PSNo);
        this.memForm.get('memName')?.setValue(this.membersList.member_Name);
        this.memForm.get('memShortName')?.setValue(this.membersList.member_Short_Name);
        this.memForm.get('webLogin')?.setValue(this.membersList.ecc_Web_Login);
        this.memForm.get('emailId')?.setValue(this.membersList.eMail_Id);
        this.memForm.get('mobileNoPrefix')?.setValue(this.membersList.mobile_No_Prefix != '' ? this.membersList.mobile_No_Prefix : '+91');
        this.memForm.get('mobileNo')?.setValue(this.membersList.mobile_No);
        this.memForm.get('designation')?.setValue(this.membersList.designation);
        this.memForm.get('status')?.setValue(this.membersList.is_Active);
        this.memForm.get('txtAddress')?.setValue(this.membersList.address);
        this.formMarkAsTouched(this.memForm);
    }

    formMarkAsTouched(form: any | FormGroup) {
        if (form.valid)
            Object.keys(form.controls).forEach(key => {
                form.get(key).markAsTouched();
            });
    }

    /**
     * setMemberType
     * @param event 
     */
    setMemberType(event: { value: string; }) {
        this.selectedOption = event.value;
        if (this.selectedOption == 'othMember') {
            this.setOtherMemerFormControls();
        }
        else {
            this.setLntMemberFormControls()
        }
    }

    setLntMemberFormControls() {
        this.isInternalUser = true;
        if (this.memForm.contains('password'))
            this.memForm.removeControl('password');
        if (!this.memForm.contains('psNo'))
            this.memForm.addControl('psNo', this.psNo);
    }

    setOtherMemerFormControls() {
        this.isInternalUser = false;
        if (this.memForm.contains('psNo'))
            this.memForm.removeControl('psNo');
        if (!this.memForm.contains('password') && !this.isEditUser) {
            this.memForm.addControl('password', this.password);
            this.passwordChangeIndicator();
        }
    }

    private passwordChangeIndicator() {
        //Capture password changes
        let _password: any = this.memForm.get('password')?.valueChanges.subscribe((val: string) => {
            if (val) {
                this._is8Characters = this._extMemberService.containAtLeastEightChars(val);
                this._isSymbols = this._extMemberService.containAtLeastOneSpecialChar(val, this.criteriaMap);
                this._isComplexWord = this._extMemberService.containsMixedChars(val, this.criteriaMap);
            }
        });
        this.UnsubscribeArray.push(_password);
    }

    /**
     * Save member details
     */
    saveMember() {
        if ((this.isInternalUser && this.isValidLntUser) || !this.isInternalUser) {
            let member: IMemebersViewModel = {
                member_Name: this.getFormValue('memName'),
                member_Short_Name: this.getFormValue('memShortName'), ecc_Web_Login: this.getFormValue('webLogin').trim(), eMail_Id: this.getFormValue('emailId'),
                is_Active: this.getFormValue('status'), mobile_No_Prefix: this.getFormValue('mobileNoPrefix'), mobile_No: this.getFormValue('mobileNo'), designation: this.getFormValue('designation'),
                reporting_To: null, member_Id: this.membersList != null ? this.membersList.member_Id : null, group_Id: this.memForm.get('businessGroup')?.value['group_Id'],
                is_Internal: this.isInternalUser, user_Id: this.memberId, address: this.getFormValue('txtAddress'), group_Name: null
            };
            if (!this.isInternalUser && !this.isEditUser) {
                member.password = this.encryptDecryptService.encrypt(this.getFormValue('password'));
            }
            if (this.isInternalUser && this.isValidLntUser) {
                member.staff_PSNo = this.getFormValue('psNo')
                member.eIP_UserId = this.getFormValue('eipUserId')
                member.company_Code = this.getFormValue('companyCode')
            }
            let _insertUpdateMemberDetails = this._extMemberService.InsertUpdateMemberDetails(member).subscribe((res: StandardOutputModel) => {
                if (res.successCode == 200) {
                    if (this.membersList == null)
                        member.member_Id = +res.result;
                    this._dialogRef.close({ response: res, member: member });
                }
                else {
                    this._dialogRef.close({ response: res });
                }
            }, err => {

            });
            this.UnsubscribeArray.push(_insertUpdateMemberDetails);
        }
        else {
            if (this.isInternalUser && !this.isValidLntUser)
                this._notificationService.showPopup("Please provide valid Staff PS No & ECC Web login", "Warning");
            else
                this._notificationService.showPopup("Mandatory fields are missing", "Warning");
        }
    }

    /**
     * Get MemForm Controls value
     * @param controlName ControlName
     */
    getFormValue(controlName: string): any {
        return this.memForm.get(controlName)?.value;
    }

    /**
     * Close modal dialog
     */
    closeDialog() {
        this._dialogRef.close();
    }

    /*
        Sheriya changes commented for production issue
    */
    // searchOnChange() {
    //     this.isexistUser = false;
    //     this.searchList = [];
    //     let searchText: string = this.searchInput.nativeElement.value;
    //     if (searchText.length <= 2)
    //         return;
    //     let filteredList: IMemebersViewModel[] = this.copymemberList.filter(item => item.ecc_Web_Login == searchText);
    //     if (filteredList.length >= 1) {
    //         this.isexistUser = true;
    //     }
    //     let search: IMemeberloginInputModel = {
    //         suggestion: searchText
    //     }
    //     let _getwebLoginList = this._extMemberService.GetwebLoginList(search).subscribe((data: IMemeberloginViewModel[]) => {
    //         this.searchList = data;
    //     })
    //     this.UnsubscribeArray.push(_getwebLoginList);
    // }
    // autoCompleteChange(event: any) {
    //     this.isexistUser = false;
    //     this.memForm.get('webLogin')?.setValue(event.login_Name);
    // }


    ngOnDestroy(): void {
        this.UnsubscribeArray.forEach(x => x.unsubscribe());
    }

}
